export const GSTR9_REPORT_REQUEST = 'GSTR9_REPORT_REQUEST';
export const GSTR9_REPORT_SUCCESS = 'GSTR9_REPORT_SUCCESS';
export const GSTR9_REPORT_FAILURE = 'GSTR9_REPORT_FAILURE';